/** @format */

import { CommonModule } from '@angular/common';
import { HomeFieldRecommendationCardComponent } from './recommendation-card.component';
import { HomefieldProductImageModule } from '../product-image/product-image.module';
import { NgModule } from '@angular/core';
// Components

@NgModule({
  imports: [CommonModule, HomefieldProductImageModule],
  declarations: [HomeFieldRecommendationCardComponent],
  exports: [HomeFieldRecommendationCardComponent],
})
export class HomeFieldRecommendationCardModule {}
